import { useEffect, useState } from 'react';
import { TooltipTypes } from './tooltip.types';

const Tooltip: (props: TooltipTypes) => JSX.Element = ({ tooltipText }) => {
  const [showInfo, setShowInfo] = useState<boolean>(false);

  function toggleTooltip(event: KeyboardEvent): void {
    if (event.key === 'Escape') {
      setShowInfo(false);
    }
    if (event.key === 'Enter') {
      setShowInfo(true);
    }
  }

  useEffect(() => {
    if (showInfo) {
      window.addEventListener('keydown', toggleTooltip);
    } else {
      window.removeEventListener('keydown', toggleTooltip);
    }

    return () => {
      window.removeEventListener('keydown', toggleTooltip);
    };
  }, [showInfo]);

  return (
    <button
      className="icon-kreis-gefuellt-info infoIcon tooltip"
      onMouseEnter={() => setShowInfo(true)}
      onMouseLeave={() => setShowInfo(false)}
      onFocus={() => setShowInfo(true)}
      onBlur={() => setShowInfo(false)}
    >
      <span
        className="tooltiptext"
        aria-label={tooltipText}
        style={{
          visibility: showInfo ? 'visible' : 'hidden',
          opacity: showInfo ? 1 : 0,
        }}
      >
        {tooltipText}
      </span>
    </button>
  );
};

export default Tooltip;
